import React from "react";
import FeedList from "../../../pages/Feeds/FeedList";

interface ArticlesProps {
  isPublicPage?: boolean;
  feeds?: any[];
  headerUser?: {
    name?: string;
    profile_image?: string;
    isCompany?: boolean;
  };
}

function Articles({ isPublicPage, feeds, headerUser }: ArticlesProps) {
  const hasProfileArticles = !!isPublicPage && Array.isArray(feeds);
  return (
    <>
      <div className="feed-wrapper article-cards">
        {hasProfileArticles ? (
          <FeedList
            pageSize={3}
            fetchOnScroll={false}
            feedArticle={true}
            readOnly={true}
            feeds={feeds}
            headerUser={headerUser}
          />
        ) : (
          <FeedList
            myPosts="my-article"
            pageSize={3}
            fetchOnScroll={false}
            feedArticle={true}
            readOnly={isPublicPage}
          />
        )}
      </div>
    </>
  );
}

export default Articles;
